export default __webpack_public_path__ + "static/media/hvac-size-details.26608084.png";